import React from 'react';
import { ecuNodes } from '../../data/console';
import type { NodeState } from '../../types/console';
const dotClass: Record<NodeState, string> = {
  secured: 'h-2.5 w-2.5 bg-secure animate-pulse-secure',
  monitoring: 'h-3 w-3 bg-accent animate-pulse-hub',
  blocked: 'h-2.5 w-2.5 bg-alert animate-pulse-blocked'
};
const statusClass: Record<NodeState, string> = {
  secured: 'text-secure',
  monitoring: 'text-accent-ink',
  blocked: 'text-alert'
};
const statusLabel: Record<NodeState, string> = {
  secured: 'Secured',
  monitoring: 'Monitoring',
  blocked: 'Blocked'
};
export function VehicleSchematic() {
  return <div className="relative h-[198px] overflow-hidden rounded-xl border border-line bg-panel" data-id="element-71" data-mp="3oxdyssfno055">
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-1.5 top-0 h-[34px] animate-sweep bg-[linear-gradient(to_bottom,transparent,rgba(109,40,217,0.10),transparent)]" data-id="element-72" data-mp="3tvxn2zhq1o0o" />

      <svg viewBox="0 0 436 198" preserveAspectRatio="none" aria-hidden="true" className="absolute inset-0 h-full w-full" data-id="element-73" data-mp="3kty2jx7i01sz">
        <rect x="163" y="8" width="110" height="150" rx="34" className="fill-accent/[0.06] stroke-accent/70" strokeWidth="1.3" data-id="element-74" data-mp="bi98w58epd7p" />
        <rect x="178" y="30" width="80" height="58" rx="14" className="fill-accent/[0.08] stroke-accent/50" strokeWidth="1" data-id="element-75" data-mp="kj7egryhtsse" />
        <rect x="156" y="26" width="12" height="26" rx="5" className="fill-panel stroke-line" data-id="element-76" data-mp="3nzxnlfpdglyb" />
        <rect x="268" y="26" width="12" height="26" rx="5" className="fill-panel stroke-line" data-id="element-77" data-mp="6jg4r3f0eyk7" />
        <rect x="156" y="118" width="12" height="26" rx="5" className="fill-panel stroke-line" data-id="element-78" data-mp="1rent46wcjnu" />
        <rect x="268" y="118" width="12" height="26" rx="5" className="fill-panel stroke-line" data-id="element-79" data-mp="3a6pwdp57dsh5" />

        <line x1="218" y1="18" x2="218" y2="150" className="stroke-accent/60" strokeWidth="1.4" strokeDasharray="3,4" data-id="element-80" data-mp="3596iwrgbxjq9" />
        <line x1="184" y1="95" x2="218" y2="95" className="stroke-accent/60" strokeWidth="1.4" strokeDasharray="3,4" data-id="element-81" data-mp="1e3jrgcp9e8c3" />
        <line x1="218" y1="95" x2="252" y2="95" className="stroke-accent/60" strokeWidth="1.4" strokeDasharray="3,4" data-id="element-82" data-mp="1mwwtc45awkab" />

        <line x1="218" y1="18" x2="302" y2="12" className="stroke-line" data-id="element-83" data-mp="v4pdv71j7dxi" />
        <line x1="218" y1="60" x2="150" y2="52" className="stroke-line" data-id="element-84" data-mp="z72j7ucd99tr" />
        <line x1="252" y1="95" x2="312" y2="88" className="stroke-line" data-id="element-85" data-mp="z96vazkf5f54" />
        <line x1="184" y1="95" x2="122" y2="103" className="stroke-line" data-id="element-86" data-mp="146ymfrd8ox89" />
        <line x1="218" y1="122" x2="304" y2="130" className="stroke-line" data-id="element-87" data-mp="2an0xccmeim1u" />
        <line x1="218" y1="150" x2="150" y2="160" className="stroke-line" data-id="element-88" data-mp="2fl2f8u83cfbq" />
      </svg>

      <ul className="absolute inset-0" data-id="element-89" data-mp="2fn5cnzbkpaqh">
        {ecuNodes.map(node => <li key={node.id} data-id="element-90" data-mp="2pohg581fopsj">
            <span aria-hidden="true" className={`absolute z-[2] -translate-x-1/2 -translate-y-1/2 rounded-full ${dotClass[node.state]}`} style={{
          left: `${node.x}%`,
          top: `${node.y}%`
        }} data-id="element-91" data-mp="2kq6bdbpzx5h6" />
            <div className={`absolute z-[2] w-[28%] leading-snug ${node.align === 'left' ? 'text-right' : 'text-left'}`} style={{
          left: `${node.labelX}%`,
          top: `${node.labelY}%`
        }} data-id="element-92" data-mp="2bx2xx3fcosmj">
              <p className="text-[9.5px] font-bold uppercase tracking-[0.03em] text-heading" data-id="element-93" data-mp="1x0lkm6nlp3xc">
                {node.name}
              </p>
              <p className={`mt-0.5 inline-flex items-center gap-1 text-[9px] font-semibold ${statusClass[node.state]} ${node.align === 'left' ? 'flex-row-reverse' : ''}`} data-id="element-94" data-mp="1t0bjb7ar71ot">
                <span aria-hidden="true" className="h-[5px] w-[5px] shrink-0 rounded-full bg-current" data-id="element-95" data-mp="3nb6rw9lxugrl" />
                {statusLabel[node.state]}
              </p>
            </div>
          </li>)}
      </ul>
    </div>;
}